import * as Yup from 'yup'
import { BaseEntity } from '../../../../shared/models/ApiModels'

export interface IUserModel extends BaseEntity { 
  firstName: string
  lastName: string
  email: string
  username: string
  password: string
  passwordConfirm: string
  roleId: string
  branchId: string
  phone: string
  image: string | null
  active: boolean
  mustChangePassword: boolean
}

export const initialUser: IUserModel = { 
  id: '',
  firstName: '',
  lastName: '',
  email: '',
  username: '',
  password: '',
  passwordConfirm: '',
  roleId: '',
  branchId: '',
  phone: '',
  image: null,
  active: true,
  mustChangePassword: false,
}

export const validationUser = Yup.object().shape({
  firstName: Yup.string().required('Ad zorunludur').min(2, 'En az 2 karakter'),
  lastName: Yup.string().required('Soyad zorunludur').min(2, 'En az 2 karakter'),
  email: Yup.string().email('Geçerli bir e-mail giriniz').required('E-mail zorunludur'),
  username: Yup.string()
    .required('Kullanıcı adı zorunludur')
    .min(3, 'En az 3 karakter')
    .matches(/^[a-zA-Z0-9._-]+$/, 'Sadece harf, rakam, nokta, tire ve alt çizgi kullanılabilir'),
  password: Yup.string()
    .required('Şifre zorunludur')
    .min(8, 'En az 8 karakter')
    .matches(/[A-Z]/, 'En az bir büyük harf içermelidir')
    .matches(/[0-9]/, 'En az bir rakam içermelidir'),
  passwordConfirm: Yup.string()
    .required('Şifre tekrarı zorunludur')
    .oneOf([Yup.ref('password')], 'Şifreler eşleşmiyor'),
  roleId: Yup.string().required('Rol seçimi zorunludur'),
})

export const validationUserEdit = Yup.object().shape({
  firstName: Yup.string().required('Ad zorunludur').min(2, 'En az 2 karakter'),
  lastName: Yup.string().required('Soyad zorunludur').min(2, 'En az 2 karakter'),
  email: Yup.string().email('Geçerli bir e-mail giriniz').required('E-mail zorunludur'),
  username: Yup.string()
    .required('Kullanıcı adı zorunludur')
    .min(3, 'En az 3 karakter')
    .matches(/^[a-zA-Z0-9._-]+$/, 'Sadece harf, rakam, nokta, tire ve alt çizgi kullanılabilir'),
  roleId: Yup.string().required('Rol seçimi zorunludur'),
})
